import style from "./style.module.scss";
import Circle from "../Common/Circle";

export default function PinkForm({ forMagazine }) {
  return (
    <div
      className={"row " + style.pinkForm}
      style={
        forMagazine
          ? {
              marginTop: 0,
              backgroundColor: "white",
              color: "black",
            }
          : {}
      }
    >
      {/* {(!forMagazine) && <Circle />} */}

      <div className={style.body}>
        <div className={style.leftCnt}>
          <div className={style.subCnt}>
            <div className={style.title + " title-font"}>
              Laat ons even
              <br />
              vrijblijvend Kennismaken?
            </div>
            <div className={style.text}>
              Eerst luisteren we, om u dan nog beter
              <br />
              te kunnen helpen en bij te staan in de
              <br />
              spannende zoektocht naar uw droom-
              <br />
              woning onder de Spaanse zon.
            </div>
          </div>
          {/* <div className={style.title}>
                    Contacteer ons
                </div> */}
          {/* <div className={style.left}>
                    <p>


                        <div className={style.topText}>
                            (U kan een of meerdere keuzes aanvinken)
                        </div>

                        {titles.map(data => <TitleItem {...data} />)}
                    </p>
                </div> */}
        </div>
        <div className={style.right}>
          <p className={style.contacts}>
            <b>Vhenga</b>
            <br />
            Urb. Cancella de la quinta
            <br />
            Calle Agua Marina 51
            <br />
            Local 1/2
            <br />
            Marbella 29670
            <br />
            Espana
            <br />
            + 32 468 07 51 68
            <br />
            + 34 633 31 84 62 <br />
            info@vhenga.com
          </p>
          <div className={style.inputs}>
            <div className={style.doubleInput}>
              <input placeholder="Naam*" />
              <input placeholder="Voornaam*" />
            </div>
            <div className={style.doubleInput}>
              <input placeholder="E-mailadres*" />
              <input placeholder="Mobile/Tel**" />
            </div>
            <input placeholder="Vraag" />
            <input placeholder="Wanneer past terugbellen u best?" />
            {/* <textarea placeholder="message" /> */}
            <button className={style.submit}>verzenden</button>
          </div>
        </div>
      </div>
    </div>
  );
}
